/**
 * Non-hook util for next gen workspaces truncated panel gen feature flag.
 * The value is cached from useStatsigGateNgwTruncatedPanelGen results.
 */

let cachedEnabled = false;

export function setNgwTruncatedPanelGenEnabled(value: boolean): void {
  cachedEnabled = value;
}

export function isNgwTruncatedPanelGenEnabled(): boolean {
  return cachedEnabled;
}
